import { Component, Input, OnInit , CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { WorkflowStageDataStatus } from "../../../enums/workflowstagedatastatus";
import { IWorkflowStageData, IWorkflowUser, IWorkflowSecurityGroup } from "../../../interfaces/iworkflow";

@Component({
    selector: "workflowstagedatastatus",
    templateUrl: "./workflowstagedatastatus.component.html",
    standalone: true,
    imports: [CommonModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class WorkflowStageDataStatusComponent implements OnInit {
    workflowStageDataStatus: any = WorkflowStageDataStatus;
    currentStage: IWorkflowStageData;
    @Input() small: boolean = false;
    @Input() workflowStages: IWorkflowStageData[];

    ngOnInit(): void {
        this.currentStage =
            this.workflowStages.find(stage => stage.statusId === this.workflowStageDataStatus.InProgress);
    }

    getUsers(step: IWorkflowStageData): string {
        let users : string = "";
        let firstUser : boolean = true;
        if(step.security) {
            for (let security of step.security) {

                if(!firstUser) {
                     users += ", \n";
                } else {
                    firstUser = false;
                }

                if (security as IWorkflowUser) {
                    users += security.name + " (" + (security as IWorkflowUser).email + ")";
                } else if (security as IWorkflowSecurityGroup) {
                    users += security.name;
                }
            }
        }
        return users;
    }
}

